import CardHolderDetails from './CardHolderDetails';
export default CardHolderDetails;